import React from 'react'

function LoadingScreen() {
  return (
    <div className="spinner-container">
    <div className="loading-spinner">
    </div>
  </div>
  )
}

export default LoadingScreen
